import { MouseEvent } from 'react';
import { useRouter } from 'next/navigation';
import { AppNextLink } from '@/features/app-next-link';
import { IconArrowSquareLeft } from '@/features/icons';
import { cn } from '@/utils/cn';
import SubMenuExpandablePanel from './sub-menu-expandable-panel';
import { useCategoryModal } from '../../category-modal/context/category-modal-context';
import { Categories, MobileMenuItems } from '../../types';
interface Props {
  title: string;
  id: string;
  parentMenuHref: string;
  subMenuChildren?: Categories[];
  className?: string;
}
function SubMenuContent({
  title,
  id,
  subMenuChildren,
  parentMenuHref,
  className
}: Props) {
  const router = useRouter();
  const {
    close: closeCategoryModal
  } = useCategoryModal();
  const preTitle = id === MobileMenuItems.Appliancese ? 'همه ' : 'همه محصولات ';
  const handleNavigate = (href: string) => {
    closeCategoryModal();
    router.replace(href);
  };
  const handleLinkItemClick = (e: MouseEvent, href: string) => {
    e.preventDefault();
    handleNavigate(href);
  };
  return <div className={cn('hide-scrollbar mt-2 flex w-full grow flex-col items-start justify-between overflow-auto rounded-md bg-white md:mt-0', className)} data-sentry-component="SubMenuContent" data-sentry-source-file="sub-menu-content.tsx">
            <div className='flex w-full flex-col gap-0 bg-white [&>a]:text-body-14'>
                {id !== MobileMenuItems.SpecialOffer && <div onClick={() => handleNavigate(parentMenuHref)} className='flex w-full items-center justify-between px-2 py-2.5 text-primary-main'>
                        <span className='text-body-14 font-medium'>
                            {preTitle}
                            <AppNextLink href={parentMenuHref} prefetch={false} onClick={e => handleLinkItemClick(e, parentMenuHref)}>
                                {title}
                            </AppNextLink>
                        </span>
                        <IconArrowSquareLeft className='h-6 w-6' />
                    </div>}

                {subMenuChildren?.map(({
        categories
      }, index) => categories.map(category => {
        const categoryHref = category.useHrefWithoutParent ? category.href : `${parentMenuHref}${category.href}`;
        return category.links?.length ? <SubMenuExpandablePanel title={category.title} key={`${category.title}${index}`} links={category.links || []} parentLink={categoryHref} /> : <AppNextLink className='flex w-full items-center justify-between px-2 py-2.5 text-text-black' href={categoryHref} prefetch={false} key={`${category.title}${index}`} onClick={e => handleLinkItemClick(e, categoryHref)}>
                                <span className='text-sm font-medium leading-6'>{category.title}</span>
                                <IconArrowSquareLeft className='h-6 w-6' />
                            </AppNextLink>;
      }))}
            </div>
        </div>;
}
export default SubMenuContent;